export class NotificationManager {
  refreshNotifications(notifications) {
    const notificationElements = document.getElementsByTagName('rts-notification');
    const visibleSlotIds = [...notificationElements].map((el) => el.slotId);

    for (let el of notificationElements) {
      const slotId = el.getAttribute('slot-id');
      if (visibleSlotIds.includes(slotId)) {
        const slotNotifications = notifications.filter((notification) =>
          notification.slotIds.includes(slotId)
        );

        el.render(slotNotifications);
      }
    }
  }
}
